export const creatorHelperResultStatuses = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const autoCreationResults = {
  CREATED: 'created',
  CREATED_PENDING_OUTCOME_UPDATE: 'created_pending_outcome_update',
  ARCHIVED: 'archived',
  NOT_CREATED_TAGTYPE_PENDING_CREATION: 'not_created_tagtype_pending_creation',
  CREATED_PENDING_REASONCODE_UPDATE: 'created_pending_reasoncode_update',
};
